export default __webpack_public_path__ + "static/media/pogot-screenshot-04.f09586b0.png";